import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdatePartSubType = ClientInferResponseBody<typeof contract.parts.updatePartSubType>;

type UpdatePartSubTypeDto = ClientInferRequest<typeof contract.parts.updatePartSubType>["body"];

export const updatePartSubType = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdatePartSubTypeDto;
}): Promise<UpdatePartSubType> => {
  const response = await api.parts.updatePartSubType.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update PartSubType", response.status, response.body);
};
